import { render, staticRenderFns } from "./concession.vue?vue&type=template&id=64986a4e"
import script from "./concession.vue?vue&type=script&lang=js"
export * from "./concession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports